import Vue from "vue";
import Vuex from "vuex";
import * as modules from "./modules/index";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    ...modules,
  },
  state: {
    Contacts: [],
    userImage: null,
    isShowPastMeetings: false,
    isHideUnAssignedAgenda: false,
    agendaGridHeight: 0,
    agendaGridWidth: 0,
    appTenant: "dev",
    isAPIError: false,
    isAPIErrorMsg: null,
    isAPIErrorKey: null,
    alertMessage: null,
    switchTenantId: null,
    isScheduleMeetingError: false
  },
  mutations: {
    StoreContacts(state, contacts) {
      state.Contacts = contacts;
    },

    StoreUserImage(state, image) {
      state.userImage = image;
    },

    StoreIsShowPastMeetings(state, isShowHistory) {
      state.isShowPastMeetings = isShowHistory;
    },

    StoreIsHideUnassignedAgenda(state, isHideUnAssigned) {
      state.isHideUnAssignedAgenda = isHideUnAssigned;
    },

    StoreAgendaGridHeight(state, gridHeight) {
      state.agendaGridHeight = gridHeight;
    },
    StoreAgendaGridWidth(state, gridWidth) {
      state.agendaGridWidth = gridWidth;
    },
    setTenant(state, tenant) {
      state.appTenant = tenant;
    },
    setAPIErrorStatus(state, status) {
      state.isAPIError = status;
    },
    setAPIErrorMessage(state, msg) {
      state.isAPIErrorMsg = msg;
    },
    setAPIErrorKey(state, key) {
      state.isAPIErrorKey = key;
    },
    setAlert(state, message) {
      state.alertMessage = message;
    },
    setSwitchTenantId(state, id) {
      state.switchTenantId = id;
    },
    setScheduleMeetingError(state, isError) {
      state.isScheduleMeetingError = isError;
    },
  },
  actions: {
    hello() {
      return "hello";
    },
  },
});
